import { Component, Input } from '@angular/core';
import { Goal } from '@/core/interfaces';

@Component({
  selector: 'goals-list',
  templateUrl: './goals-list.component.html',
  styleUrls: ['./goals-list.component.css'],
  standalone: false,
})
export class GoalsListComponent {
  @Input() goalsList!: Goal[];
  @Input() showMoreInfoIcon!: boolean;

  showAllToolsHiddenMessage() {
    return (
      this.goalsList.filter((g) => g.hidden).length === this.goalsList.length
    );
  }

  constructor() {}
}
